//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uuidv1 from 'uuid/v1';

import MemberGender from '../../../profile/form/MemberGender.vue';
import MemberFirstName from '../../../profile/form/MemberFirstName.vue';
import MemberLastName from '../../../profile/form/MemberLastName.vue';
import MemberBirthDate from '../../../profile/form/MemberBirthDate.vue';
import MemberEmail from '../../../profile/form/MemberEmail.vue';
import MemberTeamName from '../../../profile/form/MemberTeamName.vue';

export default {
  name: 'RegistrationStepSoulFocus',
  components: {
    MemberGender,
    MemberFirstName,
    MemberLastName,
    MemberBirthDate,
    MemberEmail,
    MemberTeamName,
  },
  props: ['completed', 'termsLink', 'conditionsLink'],
  data() {
    return {
      open: false,
      id: uuidv1(),
      loading: false,
      tcAccepted: false,
      formIsValid: null,
      userData: {
        emailAddress: null,
        firstName: null,
        lastName: null,
        birthDate: null,
        gender: null,
        teamName: null,
      },
      hasAccepted: false,
    };
  },
  created() {
    this.$container.eventBus.on('closeModal', (id) => {
      if (id === this.id) {
        this.close();
      }
    });
  },
  methods: {
    async completeSurvey() {
      // ADD ref for save function of the survey
      if (!this.isValid) {
        throw new Error('Please provide the data needed.');
      } else {
        this.$emit('update:completed', this.userData);
      }
      this.close();
    },
    launch() {
      this.open = true;
      this.$store.dispatch('pushModal', this.id);
    },
    close() {
      this.open = false;
      this.$store.dispatch('popModal');
    },
  },

  computed: {
    isValid() {
      const checkValid = JSON.parse(JSON.stringify(this.userData));
      console.log(checkValid);
      delete checkValid.teamName;
      console.log(checkValid);
      console.log('isValid', !Object.values(checkValid).some(item => item === null || item === undefined));
      if (!this.isValidEmail) return false;
      return !Object.values(checkValid).some(item => item === null || item === undefined);
    },
    isValidEmail() {
      return String(this.userData.emailAddress)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    },
  },
};
